import { Pants } from '@/assets/images';
import type { IAvatarAccessory } from '../types';

export const PANTS: IAvatarAccessory[] = [
  {
    id: 'P001',
    available: true,
    colorPicker: true,
    name: 'Pants_Dress',
    icon: <img src={Pants.Pants1} />,
    colors: ['#DB0007', '#FFBC0D', '#E87531', '#DB0C67']
  },
  {
    id: 'P002',
    available: true,
    colorPicker: true,
    name: 'Pants_Tightdress',
    icon: <img src={Pants.Pants2} />,
    colors: ['#DB0008', '#E87531', '#DB0C67', '#33BFD2']
  },
  {
    id: 'P003',
    available: true,
    colorPicker: true,
    name: 'Pants_SkirtBroken',
    icon: <img src={Pants.Pants3} />,
    colors: ['#FFBC0D', '#E87531', '#DB0C67', '#419EC9']
  },
  {
    id: 'P004',
    available: true,
    colorPicker: true,
    name: 'Pants_SkirtShort',
    icon: <img src={Pants.Pants4} />,
    colors: ['#1EC383', '#9A488B', '#FFBC0D', '#33BFD2']
  },
  {
    id: 'P005',
    available: true,
    colorPicker: true,
    name: 'Pants_CocktailCrocks',
    icon: <img src={Pants.Pants5} />,
    colors: ['#DB0007', '#FFBC0D', '#DB0C67', '#33BFD2']
  },
  {
    id: 'P006',
    available: true,
    colorPicker: true,
    name: 'Pants_CocktailSandels',
    icon: <img src={Pants.Pants6} />,
    colors: ['#DB0007', '#FFBC0D', '#E87531', '#DB0C67']
  },
  {
    id: 'P007',
    available: true,
    colorPicker: true,
    name: 'Pants_SneakerDress',
    icon: <img src={Pants.Pants7} />,
    colors: ['#DB0007', '#9A488B', '#FFBC0D', '#33BFD2']
  },
  {
    id: 'P008',
    available: true,
    colorPicker: true,
    name: 'Pants_Simple',
    icon: <img src={Pants.Pants8} />,
    colors: ['#33BFD2', '#FFBC0D', '#E87531', '#DB0C67']
  },
  {
    id: 'P009',
    available: true,
    colorPicker: true,
    name: 'Pants_SimpleCrocks',
    icon: <img src={Pants.Pants9} />,
    colors: ['#33BFD2', '#DB0007', '#E87531', '#DB0C67']
  },
  {
    id: 'P010',
    available: true,
    colorPicker: true,
    name: 'Pants_Rollerskates',
    icon: <img src={Pants.Pants10} />,
    colors: ['#DB0007', '#FFBC0D', '#E87531', '#33BFD2']
  },
  {
    id: 'P011',
    available: false,
    colorPicker: false,
    name: 'Pants_Amalie',
    icon: <img src={Pants.Pants11} />
  },
  {
    id: 'P012',
    available: true,
    colorPicker: true,
    name: 'Pants_Awesome',
    icon: <img src={Pants.Pants12} />,
    colors: ['#33BFD2', '#419EC9', '#151515', '#8C4900']
  },
  {
    id: 'P013',
    available: true,
    colorPicker: true,
    name: 'Pants_Disco',
    icon: <img src={Pants.Pants13} />,
    colors: ['#419EC9', '#DB0007', '#419EC9', '#E87531']
  },
  {
    id: 'P014',
    available: true,
    colorPicker: true,
    name: 'Pants_Disco2',
    icon: <img src={Pants.Pants14} />,
    colors: ['#1EC383', '#DB0007', '#FFBC0D', '#E87531']
  },
  {
    id: 'P015',
    available: true,
    colorPicker: true,
    name: 'Pants_ShortsBroken',
    icon: <img src={Pants.Pants15} />,
    colors: ['#419EC9', '#FFBC0D', '#E87531', '#DB0C67']
  },
  {
    id: 'P016',
    available: true,
    colorPicker: true,
    name: 'Pants_LongshortsSocks',
    icon: <img src={Pants.Pants16} />,
    colors: ['#DB0007', '#FFBC0D', '#E87531', '#419EC9']
  },
  {
    id: 'P017',
    available: true,
    colorPicker: true,
    name: 'Pants_LongshortsUggs',
    icon: <img src={Pants.Pants17} />,
    colors: ['#33BFD2', '#419EC9', '#E87531', '#DB0C67']
  },
  {
    id: 'P018',
    available: true,
    colorPicker: true,
    name: 'Pants_LongshortsCrocs',
    icon: <img src={Pants.Pants18} />,
    colors: ['#33BFD2', '#DB0007', '#E87531', '#DB0C67']
  },
  {
    id: 'P019',
    available: true,
    colorPicker: true,
    name: 'X_Pants_WidePants1',
    icon: <img src={Pants.Pants19} />,
    colors: ['#33BFD2', '#DB0012', '#E87539', '#DB0C75']
  },
  {
    id: 'P020',
    available: true,
    colorPicker: true,
    name: 'X_Pants_WidePants2',
    icon: <img src={Pants.Pants20} />,
    colors: ['#1EC383', '#DB0012', '#FFBC0D', '#E87537']
  }
];
